import React, {useCallback, useState} from 'react';

/**
 * Keyboard helpers for react-select inside a parent <form>.
 * Enter with the menu closed would otherwise submit the form.
 */
export function useReactSelectKeyboard() {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const onMenuOpen = useCallback(() => setMenuIsOpen(true), []);
  const onMenuClose = useCallback(() => setMenuIsOpen(false), []);

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' && !menuIsOpen) {
        event.preventDefault();
        setMenuIsOpen(true);
      }
    },
    [menuIsOpen],
  );

  return {menuIsOpen, onMenuOpen, onMenuClose, onKeyDown, setMenuIsOpen};
}
